<template>
    <div>
        <template v-if="headline">
            <div class="flex flex-col">
                <p class="text-sm ml-3 dark:text-gray-100 mb-2 text-gray-500" v-html="markdownParser(message)"></p>
                <a :href="url"
                   class="flex gap-3 rounded-xl border border-gray-300 bg-gray-100 dark:border-gray-800 p-3 hover:bg-gray-50  dark:bg-gray-700 dark:hover:bg-gray-800 transition-colors no-underline text-inherit"
                   target="_blank">
                    <div class="flex flex-col gap-1 min-w-0">
                        <strong v-if="headline" class="text-sm text-gray-700 dark:text-gray-200 truncate">{{
                                headline
                            }}</strong>
                        <p v-if="body" class="text-xs text-gray-500  dark:text-gray-300 line-clamp-2 m-0">{{ body }}</p>
                        <span class="text-xs text-gray-400 truncate  dark:text-gray-200">{{ url }}</span>
                    </div>
                </a>
            </div>
        </template>
        <template v-else>
            <LinkPreview v-if="url !== ''" :caption="message" :is-preview="props.preview" :url="url"/>
        </template>
    </div>
</template>

<script lang="ts" setup>
import {onMounted, ref} from "vue";
import LinkPreview from "@src/components/views/HomeView/MainArea/ChatArea/Message/LinkPreview.vue";

const props = defineProps(['data', 'preview']);
const url = ref<string>('')
const message = ref<string>('')
const headline = ref<string>('')
const body = ref<string>('')

onMounted(() => {
    try {
        let data = JSON.parse(props.data);
        url.value = data.url;
        message.value = data.message;
        headline.value = data.headline ?? '';
        body.value = data.body ?? '';
    } catch (e) {
        console.error(e)
    }
})

const markdownParser = (text: string) => {
    if (!text) {
        return ''
    }

    let html = text
        .replace(/^\~(.*)\~/gim, '<span style="text-decoration: line-through;">$1</span>') // line trough
        .replace(/\*(.*)\*/gim, '<strong>$1</strong>') // bold text
        //.replace(/\_(.*)\_/gim, '<span style="font-style: italic;">$1</span>') // italic text
        .replace(/\n/g, "<br />");  // new line

    html = toHTML(html)

    html = html.replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank">$1</a>'); // link

    return html.trim(); // using trim method to remove whitespace
}

function toHTML(text: string) {
    // Regular expression pattern to match URLs
    var urlPattern = /(https?:\/\/[^\s]+)/g;

    // Regular expression pattern to match italic text
    var italicPattern = /_([^_]+)_/g;

    // Função para substituir o texto em itálico, ignorando as URLs
    return text.replace(italicPattern, function (match, p1, offset) {
        // Verifica se o texto em itálico está dentro numa URL
        if (isWithinURL(offset, urlPattern, text)) {
            return match; // Retorna o texto em itálico sem modificação
        } else {
            return '<span style="font-style: italic;">' + p1 + '</span>'; // Substitui o texto em itálico
        }
    });
}

function isWithinURL(offset: number, urlPattern: RegExp, text: string) {
    let match;
    while ((match = urlPattern.exec(text)) !== null) {
        const start = match.index;
        const end = start + match[0].length;
        if (offset >= start && offset <= end) {
            return true;
        }
    }
    return false;
}
</script>

<style scoped>

</style>